<div class="modal fade" id="kt_modal_inspection_charge_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Inspection Charge' : 'Add Inspection Charge' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="inspectionChargeForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Name -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Name</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="name"
                placeholder="Enter inspection charge name"
                [class.is-invalid]="name?.invalid && name?.touched"
              />
              <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
                <div *ngIf="name?.errors?.['required']">Name is required</div>
              </div>
            </div>

            <!-- Charge -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Charge</label>
              <input
                type="number"
                class="form-control form-control-solid"
                formControlName="charge"
                placeholder="Enter charge amount"
                min="0"
                step="0.01"
                [class.is-invalid]="charge?.invalid && charge?.touched"
              />
              <div *ngIf="charge?.invalid && charge?.touched" class="invalid-feedback">
                <div *ngIf="charge?.errors?.['required']">Charge is required</div>
                <div *ngIf="charge?.errors?.['min']">Charge must be 0 or greater</div>
              </div>
            </div>

            <!-- Hidden Type Field -->
            <input type="hidden" formControlName="type" />
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
